import { formatDate } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';

import { InternationalizationService } from '@services/utils/internationalization/internationalization.service';

@Pipe({ name: 'userDateTime' })
export class UserDateTimePipe implements PipeTransform {
    private readonly internationalizationService = inject(InternationalizationService);

    transform(value?: string | number | Date | null, timezone?: string): string {
        if (!value) {
            return '';
        }

        const date = value instanceof Date ? value : new Date(value);
        if (Number.isNaN(date.getTime())) {
            return '';
        }

        const format = `${this.internationalizationService.getDateFormat()} ${this.internationalizationService.getHourFormat()}`;

        return formatDate(date, format, this.internationalizationService.getParsedLanguage(), timezone);
    }
}
